<template>
  <div class="panel__slide-index">
    <aha-icon name="slide" />
    <span>{{ slideIndex(slideId) }}</span>
  </div>
</template>

<script>
export default {
  props: {
    slideId: {
      type: Number,
      default: null,
    },
  },

  computed: {
    slideIndex() {
      return (slideId) => {
        return this.$store.getters.getSlideIndexById({ slideId }) + 1
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.panel__slide-index {
  @apply text-base-65 text-xs;
  @apply flex items-start gap-1;
  padding-top: 2px;
}
</style>
